/* tslint:disable */
/* eslint-disable */
export enum FileCategory {
  Source = 'SOURCE',
  Result = 'RESULT',
  Main = 'MAIN'
}
